<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_notice_detail</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot  :title="pageTitle" >
            <div>
            </div>
          </title-and-slot>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
              <button class="btn btn-primary" style="min-width:100px;float: left;margin-left: -10px;" @click="backToList" >＜　戻る</button>
            </div>
          </div>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
              <!-- Coll A -->
              <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-4" style="">
              <!-- Coll B -->
              <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-4" style="">
              <field-box   v-for="f in formFields.col3"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
              <!-- Coll C -->
            </div>
            <div class="col-xs-12" style="margin-top: 15px;">
              <field-box   v-for="f in formFields.col4" 
               v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"
               :option="{label_in_new_line:true,field_style:'height: 100px!important;margin-left: -7px;margin-top: 4px;',rows:4}"
               ></field-box>
              <!-- Coll D -->
            </div>
          </div>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
              <div class="row" style="margin-bottom:10px;">
                </div>
            </div>
            <div class="col-xs-8" style="">
              <div class="row" style="margin-bottom:10px;">
                <button v-if="read_only == false"  class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;margin-right:13px;background: #92D050;border-color:#92D050;"  @click="onSave" >登録</button>
                <button
                :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
                v-if="read_only == true && this.isHistoryOnly == false" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;margin-right:13px;" @click="onEdit"  >編集</button>
                <button v-if="read_only == false" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #A6A6A6;border-color:#A6A6A6;" @click="btnCancel"  >キャンセル</button>
                <button
                :disabled="checkUserPermission(true,permissionMode.DELETE) == false"
                v-if="read_only == true && this.isHistoryOnly == false" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete">削除</button>
              </div>
            </div>
          </div>
      </div>
      <confirmation-modal tag="deleteNoticeModal" @done="onConfirmDelete" />
    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_notice';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:notice_details');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
import constants from "@/rules/constants";
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
  },
  data() {
    return {
      api_name:"notice",
      page_acl: acl.master,
      disable_edit_buttons:false
    };
  },
  computed: {
    pageTitle(){
      if(this.isHistoryOnly){
        return "お知らせ 履歴一覧";
      }else{
        return "お知らせ（詳細）";
      }
    },
    isHistoryOnly:{
      get(){
        return this.disable_edit_buttons;
      },
      set(v){
        this.disable_edit_buttons = v;
      }
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1:[
          utils.extend(fields.from_user, {disabled: true , read_only:true}),
          utils.extend(fields.message_schedule, {}),
        ],
        col2:[
          utils.extend(fields.to_company, {}),
          utils.extend(fields.to_department, {}),
          utils.extend(fields.to_team, {}),
          utils.extend(fields.to_user, {}),
        ],
        col3:[
          utils.extend(fields.importance, {}),
          utils.extend(fields.create_date, {disabled: true , read_only:true}),
        ],
        col4:[
          utils.extend(fields.message, {}),
        ],
      }
    }
  },
  methods: {
    onSave(){
      this.read_only = false;
      this.commonSaveInfo(this,this.api_name, {} );
    },
    onEdit(){
      mdebug("onEdit");
      this.startCompanySelection();
      this.commonOnEdit();
    },
    onDelete(){
      bus.$emit("deleteNoticeModal",{
        title: "削除",
        message: "お知らせの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        this.commonDelete(this);
      }
    },
    backToList(){
      if(this.isHistoryOnly){ 
        return this.$router.push({ name: "page_0090_notice_history", params: {} });
      }else{
        return this.$router.push({ name: "page_0090_notice", params: {} });
      }
    },
    prepareCompanySelection( companies, department_and_team, user_and_teams, company_field, department_field, team_field, to_user_field, company_field_name, department_field_name ,force_disable) {

      var selected_company = false;
      var selected_department = false;
      var selected_team = false
      company_field.page_controller_setup({
        on_select: (_selected_company) => {
          selected_company = _selected_company;
          if (selected_company == constants.COMMON.ALL_USERS_LABEL) {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
            to_user_field.page_controller_msg({ cmd: "disable" });
          }else if (selected_company == "") {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
            to_user_field.page_controller_msg({ cmd: "disable" });
          } else {
            var departments = _.uniq( _.map( _.filter(department_and_team || [], (d) => { return d.company == selected_company; }) || [], "department" ) || [] );
            departments.unshift("");
            department_field.page_controller_msg({ cmd: "enable" });
            department_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            to_user_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "disable" });
            department_field.page_controller_msg({
              cmd: "set_options",
              options: departments,
              reset: true,
            });
          }
        },
      });
      department_field.page_controller_setup({
        on_select: (_selected_department) => {
          selected_department = _selected_department;
          if (selected_department == "") {
            team_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            to_user_field.page_controller_msg({ cmd: "set_value", val: "" });
          } else {
            var teams = _.uniq( _.map( _.filter(department_and_team || [], (d) => { return ( d.company == selected_company && d.department == selected_department ); }) || [], "team" ) || [] );
            teams.unshift("");
            team_field.page_controller_msg({ cmd: "enable" });
            team_field.page_controller_msg({cmd:"set_value",val:""})
            team_field.page_controller_msg({ cmd: "set_options", options: teams, reset: true, });
          }
        },
      });
      team_field.page_controller_setup({
        on_select: (_selected_team) => {
          selected_team = _selected_team;
          if (selected_team == "") {
            to_user_field.page_controller_msg({ cmd: "disable" });
            // to_user_field.page_controller_msg({ cmd: "set_value", val: "" });
          } else {
            //var users = _.map( _.filter(user_and_teams || [], (d) => { return ( d.company == selected_company && d.department == selected_department  && d.team == selected_team ); }) || [], (r)=>{ return {user_id:r.user_id,user_shimei:r.user_shimei}} )||[];
            var users =  _.filter(user_and_teams || [], (d) => { return ( d.company == selected_company && d.department == selected_department  && d.team == selected_team ); }) || [];
            users.unshift({user_shimei:"",user_id:""});
            to_user_field.page_controller_msg({ cmd: "enable" });
            to_user_field.page_controller_msg({ cmd: "set_options_kv", options:users, reset: true, });
            to_user_field.page_controller_msg({ cmd: "set_value", val: "" });

            // users = users.map(m=>{ return m.user_shimei;})
            // to_user_field.page_controller_msg({ cmd: "enable" });
            // to_user_field.page_controller_msg({ cmd: "set_options_kv", option_kv: users,options:users_kv, reset: true, });
          }
        },
      });

      company_field.page_controller_msg({ cmd: "set_options", options: _.clone(companies), });
      to_user_field.page_controller_msg({ cmd: "set_options_kv", options:user_and_teams, reset: true });
      company_field.page_controller_msg({ cmd: "enable" });
      department_field.page_controller_msg({ cmd: "disable" });
      team_field.page_controller_msg({ cmd: "disable" });
      to_user_field.page_controller_msg({ cmd: "disable" });

      setTimeout(
        () => {
          department_field.page_controller_msg({ cmd: "enable_if_data" });
          team_field.page_controller_msg({ cmd: "enable_if_data" });
          to_user_field.page_controller_msg({ cmd: "enable_if_data" });

          selected_company = this.$store.state[this.stateCurrentRow][company_field.id];
          selected_department = this.$store.state[this.stateCurrentRow][department_field.id];
          if (selected_company && selected_company.length > 0) {
            department_field.page_controller_msg({ cmd: "enable" });
            var departments = _.uniq( _.map( _.filter(department_and_team || [], (d) => { return d.company == selected_company; }) || [], "department" ) || [] );
            department_field.page_controller_msg({ cmd: "set_options", options: departments, reset: false, });
            if (selected_department && selected_department.length > 0) {
              var teams = _.uniq( _.map( _.filter(department_and_team || [], (d) => { return ( d.company == selected_company && d.department == selected_department ); }) || [], "team" ) || [] );
              team_field.page_controller_msg({ cmd: "set_options", options: teams, reset: false, });
            }
          }
          if(force_disable == true){
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
            to_user_field.page_controller_msg({ cmd: "disable" });

          }
        },
        this.is_new ? 100 : 500
      );
    },
    startCompanySelection(force_disable=false){
      if(this.company_selection_started == true){
        return;
      }
      this.company_selection_started  = true;
      if (true) {
        var temp_fields = this.installedFieldList;
        // Load the companies

        this.$ajax.post_cached_queued( "/master_user/list_user_company_department_team", {}, (err, _list_user_company_department_team) => {
          if (err) {
            this.$notify({
              title: "ユーザ一覧のデータが読込めませんでした。",
              text: err,
              type: "error",
              duration: 10000,
            });
            return;
          }
          var list_user_company_department_team = _list_user_company_department_team;
          // _list_user_company_department_team.forEach((c) => {
          //   list_user_company_department_team.push(c.val);
          // });



          // this.$ajax.post_cached_queued( "/master_company/list_company_name", {}, (err, _companies) => {
          //   if (err) {
          //     this.$notify({
          //       title: "所管会社のデータが読込めませんでした。",
          //       text: err,
          //       type: "error",
          //       duration: 10000,
          //     });
          //     return;
          //   }
          //   var companies = [""];
          //   _companies.forEach((c) => {
          //     companies.push(c.val);
          //   });
          //   // Load the departments and teams
          //   this.$ajax.post_cached_queued( "/master_belongs/list_team_and_department", {}, (err, department_and_team) => {
          //       if (err) {
          //         this.$notify({
          //           title: "部署・チームのデータの読込に失敗しました。",
          //           text: err,
          //           type: "error",
          //           duration: 10000,
          //         });
          //         return;
          //       }
                var companies = _.uniq(list_user_company_department_team.map(m=>{return m.company}))
                companies.push(constants.COMMON.ALL_USERS_LABEL)
                var department_and_team = list_user_company_department_team.map(m=>{return {company:m.company,team:m.team,department:m.department}})
                this.prepareCompanySelection(
                  _.clone(companies),
                  _.clone(department_and_team),
                  _.clone(list_user_company_department_team),
                  temp_fields.to_company,
                  temp_fields.to_department,
                  temp_fields.to_team,
                  temp_fields.to_user,
                  "company",
                  "department",
                  force_disable
                );
                if (this.$route.params.seq_id == "new") {
                  var default_company = Vue.localStorage.get( temp_fields.to_company.default_from_local_storage );
                  if (default_company != constants.COMPANY.ALL) {
                    setTimeout(
                      () => {
                        var default_deparment = Vue.localStorage.get( temp_fields.to_department.default_from_local_storage );
                        var default_team = Vue.localStorage.get( temp_fields.to_team.default_from_local_storage );
                        temp_fields.to_company.page_controller_msg({
                          cmd: "set_value",
                          val: default_company,
                        });
                        // temp_fields.to_department.page_controller_msg({
                        //   cmd: "set_value",
                        //   val: default_deparment,
                        // });
                        // temp_fields.to_team.page_controller_msg(
                        //   { cmd: "set_value", val: default_team }
                        // );
                      },
                      this.is_new ? 300 : 1000
                    );
                  }
                }
              });
        //   });
        // });
      }
    }
  },
  mounted() {
    if (this.$route.params.seq_id == "new") {
      setTimeout(() => {
        this.startCompanySelection();
      }, 10);
    }else{
      setTimeout(() => {
        this.startCompanySelection(true);
      }, 10);
    }
    this.commonLoadRecord({},(err,result)=>{
      this.commonEditDeleteCmdHandler(this);
      if(this.$store.state[this.stateCurrentRow]["is_history"] == 1){
        this.isHistoryOnly = true;
      }else{
        this.isHistoryOnly = false;
      }
      if (this.$route.params.seq_id == "new") {
        this.$store.state[this.stateCurrentRow]["importance"] =3;
        this.$store.state[this.stateCurrentEditing]["importance"] =3;
      }
    })
  },
  beforeDestroy() {
  },
  beforeMount() {
  }
};

</script>
<style scoped>

input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0090_notice_detail.vue?d67a5270